"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelfController = void 0;
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Language_1 = __importDefault(require("@opsbase/lib-i18n/Language"));
const lib_self_1 = __importDefault(require("@opsbase/lib-self"));
const lib_storage_1 = require("@opsbase/lib-storage");
const FeatureStatus_1 = __importDefault(require("@opsbase/lib-system/FeatureStatus"));
const react_1 = __importStar(require("react"));
const SelfContext_1 = __importDefault(require("../useSelf/SelfContext"));
const SelfActionsContext_1 = __importDefault(require("../useSelfActions/SelfActionsContext"));
function SelfController({ children }) {
    const [ctxChanged, setCtxChanged] = (0, react_1.useState)();
    const self = (0, react_1.useRef)(new lib_self_1.default());
    const realSelf = (0, react_1.useRef)(self.current);
    const language = (0, react_1.useRef)(self.current.preferences.language || Language_1.default.ENGLISH);
    const _doSetLanguage = (0, react_1.useMemo)(() => (newLanguage) => __awaiter(this, void 0, void 0, function* () {
        language.current = newLanguage;
        yield lib_i18n_1.default.switch(newLanguage);
    }), []);
    const _doSetSelf = (0, react_1.useMemo)(() => (newSelf) => __awaiter(this, void 0, void 0, function* () {
        self.current = newSelf;
        yield _doSetLanguage(newSelf.preferences.language || Language_1.default.ENGLISH);
    }), [_doSetLanguage]);
    const setRealSelfOnly = (0, react_1.useMemo)(() => (newSelf) => __awaiter(this, void 0, void 0, function* () {
        if (!newSelf)
            newSelf = new lib_self_1.default();
        (0, lib_storage_1.setStoredValue)('self', JSON.stringify(newSelf || {}));
        realSelf.current = newSelf;
        setCtxChanged(new Date());
    }), []);
    const setSelf = (0, react_1.useMemo)(() => (newSelf) => __awaiter(this, void 0, void 0, function* () {
        if (!newSelf)
            newSelf = new lib_self_1.default();
        (0, lib_storage_1.setStoredValue)('self', JSON.stringify(newSelf || {}));
        (0, lib_storage_1.removeStoredValue)('shadow');
        realSelf.current = newSelf;
        yield _doSetSelf(newSelf);
        setCtxChanged(new Date());
    }), [_doSetSelf]);
    const setShadow = (0, react_1.useMemo)(() => (shadow) => __awaiter(this, void 0, void 0, function* () {
        if (!shadow)
            shadow = realSelf.current;
        (0, lib_storage_1.setStoredValue)('shadow', JSON.stringify(shadow || {}));
        yield _doSetSelf(shadow);
        setCtxChanged(new Date());
    }), [_doSetSelf]);
    const setSelfAndShadow = (0, react_1.useMemo)(() => (newSelf, shadow) => __awaiter(this, void 0, void 0, function* () {
        if (!newSelf)
            newSelf = new lib_self_1.default();
        (0, lib_storage_1.setStoredValue)('self', JSON.stringify(newSelf || {}));
        realSelf.current = newSelf;
        if (shadow) {
            (0, lib_storage_1.setStoredValue)('shadow', JSON.stringify(shadow));
            yield _doSetSelf(shadow);
        }
        setCtxChanged(new Date());
    }), [_doSetSelf]);
    const hasFeature = (0, react_1.useMemo)(() => flag => {
        if (!flag)
            return true;
        const features = self.current.features;
        const featureResolver = (f) => { var _a; return ((_a = features.find(z => z.name === f)) === null || _a === void 0 ? void 0 : _a.state) === FeatureStatus_1.default.ENABLED; };
        return typeof flag === 'function'
            ? flag(self.current, featureResolver)
            : featureResolver(flag);
    }, []);
    const updateSettings = (0, react_1.useMemo)(() => (settings) => {
        self.current.settings = settings;
        realSelf.current.settings = settings;
        setCtxChanged(new Date());
    }, []);
    const setLanguage = (0, react_1.useMemo)(() => (lang) => {
        _doSetLanguage(lang).catch(doNothing_1.default);
        setCtxChanged(new Date());
    }, [_doSetLanguage]);
    const actionsCtx = (0, react_1.useMemo)(() => ({
        setSelf,
        setShadow,
        setRealSelfOnly,
        setSelfAndShadow,
        updateSettings,
        hasFeature,
        setLanguage,
    }), [
        setSelf,
        setShadow,
        setRealSelfOnly,
        setSelfAndShadow,
        updateSettings,
        hasFeature,
        setLanguage,
    ]);
    const ctx = (0, react_1.useMemo)(() => ({
        self: self.current,
        realSelf: realSelf.current,
        language: language.current,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ctxChanged]);
    return (react_1.default.createElement(SelfActionsContext_1.default.Provider, { value: actionsCtx },
        react_1.default.createElement(SelfContext_1.default.Provider, { value: ctx }, children)));
}
exports.SelfController = SelfController;
exports.default = SelfController;
